import { useModalPromise } from '@cp/shared/modal';
import { COPY_PROMO_MODAL } from '../lib';

export const useCopyPromoModal = () => useModalPromise(COPY_PROMO_MODAL);
